import { ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { SectionSwapServant } from '../../../swap/servants/section_swap_servant';
import * as _4 from 'lodash4';

export class ViewSectionsFacade {
  constructor(private $state: ng.ui.IStateService, private ngSectionSwapServant: SectionSwapServant) {}

  showSections(course: ITermCourse) {
    const sectionTypeInCourse = _4.get(course, '_section_types[0].id', 0);
    const stateParameters = {
      courseId: course.id,
      sectionTypeId: sectionTypeInCourse
    };

    if (this.ngSectionSwapServant.isInSwapMode()) {
      return this.$state.go(`my.schedule.registration.swap.courseSections`, {
        ...stateParameters,
        ignoreConflicts: true,
        swapCourse: true
      });
    }

    return this.$state.go(`my.schedule.registration.courseSections`, stateParameters);
  }
}

angular.module('capability-ng-scheduler').service('ngViewSectionsFacade', ViewSectionsFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/facades/view_sections_facade.ts